import { Typography } from '@/components/ui/typography'
import { formatTarget } from '@/features/ogsm/target-format'
import type { OgsmBoardNode } from '@/types/api'

/** The objectives a publish or reopen moves, each with its goal. */
export function FlaggedObjectiveList({
  label,
  objectives,
  emptyText,
}: {
  label: string
  objectives: OgsmBoardNode[]
  emptyText?: string
}) {
  return (
    <div className="flex flex-col">
      <Typography variant="overline" className="mb-1 text-primary/60">
        {label}
      </Typography>
      {objectives.length === 0 && emptyText ? (
        <Typography variant="body-sm" className="py-1.5 text-primary/60">
          {emptyText}
        </Typography>
      ) : (
        <ul>
          {objectives.map((objective) => (
            <li
              key={objective.id}
              className="grid grid-cols-[minmax(0,1fr)_auto] items-baseline gap-2.5 border-b border-primary/10 py-1.5"
            >
              <Typography
                as="span"
                variant="body"
                className="min-w-0 break-words font-normal"
              >
                {objective.title}
              </Typography>
              <Typography
                as="span"
                variant="body"
                className="whitespace-nowrap font-semibold tabular-nums"
              >
                {formatTarget(
                  objective,
                  {
                    value: objective.targetValue,
                    text: objective.targetText,
                    date: objective.targetDate,
                  },
                  true
                )}
              </Typography>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
